<template>
    <TransitionGroup name="agent-attachment" tag="ul" class="attachment-list" aria-label="Attached files" appear>
        <li v-for="attachment in attachments" :key="attachment.id" class="attachment-item">
            <v-sheet class="attachment-preview" color="darkbase" rounded="lg" border>
                <v-img
                    v-if="attachment.preview"
                    :src="attachment.preview"
                    :alt="attachment.name"
                    width="80"
                    height="80"
                    cover />
                <div v-else class="attachment-file" :title="attachment.name">
                    <v-icon icon="fa-regular fa-file" size="24" aria-hidden="true" />
                    <span>{{ attachment.name }}</span>
                </div>
                <v-btn
                    v-if="removable"
                    class="attachment-remove"
                    icon="fa-solid fa-xmark"
                    size="x-small"
                    variant="flat"
                    color="darkbase"
                    :aria-label="`Remove ${attachment.name}`"
                    :disabled="disabled"
                    @click="$emit('remove', attachment.id)" />
            </v-sheet>
            <span class="attachment-name" :title="attachment.name">{{ attachment.name }}</span>
        </li>
    </TransitionGroup>
</template>

<script>
export default {
    name: 'AttachmentList',
    props: {
        attachments: { type: Array, default: () => [] },
        removable: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false }
    },
    emits: ['remove']
}
</script>

<style scoped>
.attachment-list {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding: 0;
    margin: 0;
    list-style: none;
}

.attachment-item {
    width: 80px;
    min-width: 0;
}

.attachment-preview {
    position: relative;
    width: 80px;
    height: 80px;
    overflow: hidden;
}

.attachment-file {
    height: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: rgb(var(--v-theme-secondary));
}

.attachment-file span,
.attachment-name {
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 11px;
}

.attachment-name {
    margin-top: 5px;
    color: rgb(var(--v-theme-secondary));
}

.attachment-remove {
    position: absolute;
    top: 4px;
    right: 4px;
}
</style>
